<template>
  <el-dialog
    title="通栏样式上传"
    :visible.sync="dialogSystemLayoutVal"
    :modal-append-to-body="false"
    custom-class="collectDialog"
  >
    <div>
      <cx-select title="通栏类别" :selectOptions="layoutTypes" :value.sync="systemLayoutId" />
    </div>
    <div class="mt16 verticallyCenter">
      <span class="w74 mr16">组件名称</span>
      <el-input class="flex1" v-model="systemLayoutForm.name" placeholder="请输入名称"></el-input>
    </div>
    <div class="mt16 verticallyTop">
      <span class="w74 mr16">上传封面</span>
      <img-upload class="flex1" :imgSrc.sync="systemLayoutCover" :noImgLib="false" :imgSize="200 + '*' + 220" />
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogSystemLayoutVal = false">取 消</el-button>
      <el-button size="small" type="primary" @click="saveSystemLayoutEv">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getTarComponentEvent } from "utils/event"
import { data_dictionary_map } from "root/static/dataDictionary"
import { encryption, getAllElementsInColsInLayoutComponent } from "utils"
import { delAnimateOutCurrentLayout } from "utils/event/animate"
import { simpleDeepClone } from '../../../utils'
export default {
  name: "update-system-layout-style",
  props: {
    dialogSystemLayout: {
      type: Boolean
    },
    selectPageLayout: {
      type: Object
    },
    isCollectSystemLayout: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      systemLayoutCover: "",
      systemLayoutType: null,
      systemLayoutId: null,
      systemLayoutForm: {
        name: null,
        type: 1
      },
      saveAddIds: [],
      allRectIds: [] //获取该通栏内所有的组件id，用来判断上传通栏样式的嘶吼是否需要剔出来
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    dialogSystemLayoutVal: {
      get() {
        return this.dialogSystemLayout
      },
      set(newVal) {
        this.systemLayoutId = null
        this.$emit("update:dialogSystemLayout", newVal)
      }
    },
    isWaterFall() {
      return this.$store.state[this.request_prefix].page.isWaterFall  === 'waterFall' ? true : false
    },
    // 通栏布局的样式类型
    layoutTypes() {
      let menuName = this.request_prefix === "appStage" ? "appMenu" : "menu"
      let otherModuleTypes = this.$store.state[menuName].menu.otherTypes
      let inDocument = this.selectPageLayout?.options?.inDocument
      const isWaterLayout = this.selectPageLayout?.layout?.rows?.[0]?.options?.waterFlow
      let pageLayoutTypeName = this.isWaterFall ? (this.request_prefix === "appStage" ? "新移动端通栏样式" : "新通栏样式") : "通栏样式"
      // 头部没有做同步到移动端优化, 先不允许头底往新的收藏里面存
      if (inDocument === "footer" || inDocument === "header") {
        pageLayoutTypeName = isWaterLayout ? (this.request_prefix === "appStage" ? "新移动端通栏样式" : "新通栏样式") : "通栏样式"
      }
      let layoutTypes = otherModuleTypes?.find(item => item.name.indexOf(pageLayoutTypeName) > -1)
      let moduleTypes = layoutTypes?.subs || []
      if (inDocument === "header" || inDocument === "relativeHeader") {
        moduleTypes = moduleTypes?.find(item => item.name.indexOf("头部通栏") > -1)?.subs || []
      } else if (inDocument === "footer") {
        moduleTypes = moduleTypes?.find(item => item.name.indexOf("底部通栏") > -1)?.subs || []
      } else if (inDocument === "anchor") {
        moduleTypes = moduleTypes?.find(item => item.name.indexOf("锚点") > -1)?.subs || []
      }
      let list = []
      moduleTypes.forEach(item => {
        if (this.isCollectSystemLayout) {
          if (item.name.indexOf("我的") > -1) {
            list.push({
              label: item.name,
              value: item.encId
            })
          }
        } else {
          if (item.name.indexOf("我的") === -1) {
            list.push({
              label: item.name,
              value: item.encId,
              subs: item.subs
            })
          }
        }
      })
      return list
    }
  },
  methods: {
    // 保存通栏样式时，需要将通栏内部的应用存为系统模块
    saveSystemLayoutEv() {
      if (this.systemLayoutForm.name !== null) {
        let isCollect = false
        let styleTypeName = this.layoutTypes.find(item => item.value === this.systemLayoutId)
        if (styleTypeName && (styleTypeName.label.trim() === "我的通栏样式" || this.isCollectSystemLayout)) {
          isCollect = true
        }
        let { inDocument, isRefHome } = this.selectPageLayout?.options
        let isCopyHome = false
        if ((inDocument === "header" || inDocument === "footer") && isRefHome) {
          isCopyHome = true
        }
        let appContent = sessionStorage.getItem("mobileLayoutStyleToPc")
        let appMoudle = null
        this.appPageLayout = null
        if (appContent && this.request_prefix !== "appStage") {
          sessionStorage.removeItem("mobileLayoutStyleToPc")
          appContent = JSON.parse(appContent)
          this.appPageLayout = this.$store.state.appStage.page.pageLayoutList[appContent.ids.pageLayoutId]
        }
        if (isCollect) {
          const moudle = this.getCollectModule(this.selectPageLayout)
          if (this.appPageLayout) {
            appMoudle = this.getCollectModule(this.appPageLayout, true)
          }
          this.createSystemComponentAppCollectFunc(moudle, isCopyHome, appMoudle)
        } else {
          const moudle = this.getSystemModule(this.selectPageLayout)
          if (this.appPageLayout) {
            appMoudle = this.getSystemModule(this.appPageLayout, true)
          }
          this.createSystemComponentAppCloneFunc(moudle, isCopyHome, appMoudle)
        }
      } else {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "您输入的数据不正确，请检查内容",
          type: "error"
        })
      }
    },
    // 收藏通栏布局组件
    getCollectModule(pageLayout, isApp) {
      this.saveAddIds = []
      this.allRectIds = []
      let rectsId = this.handleDatas(pageLayout, [], isApp)
      let rects = []
      rectsId.forEach(item => {
        rects.push(this.handleParam(item.rectId, item.appId))
      })
      if (rectsId && rectsId[0] && rectsId[0].rectId) {
        const ids = { container_id: this.ids.container_id || 0, rect_id: rectsId[0].rectId }
        const env = isApp ? "appStage" : this.request_prefix
        let content = simpleDeepClone(this.getRectAttribute.call(this, ids, env))
        if (content && content.shape === "cxPageLayoutComponent") {
          rectsId = this.handleDatas(content.options.layout, [], isApp)
          rectsId.forEach(item => {
            rects.push(this.handleParam(item.rectId, item.appId))
          })
        }
      }
      return {
        rects,
        allRectIds: [...this.allRectIds]
      }
    },
    // 设为系统模块的功能
    getSystemModule(pageLayout, isApp) {
      this.saveAddIds = []
      this.allRectIds = []
      let rectsId = this.handleDatas(pageLayout, [], isApp)
      let rects = []
      rectsId.forEach(item => {
        rects.push(this.handleParam(item.rectId, item.appId, true, isApp))
      })
      return {
        rects,
        allRectIds: [...this.allRectIds]
      }
    },
    handleDatas(layout, rects, isApp) {
      let curLayout = layout || this.selectPageLayout
      curLayout.layout.rows.forEach(item => {
        [...new Set(item.rectIds)].forEach(rectId => {
          this.allRectIds.push(rectId)
          return this.getSystemAppId(rectId, rects, isApp)
        })
        return this.handleDatas(item, rects, isApp)
      })
      curLayout.layout.cols?.forEach(item => {
        [...new Set(item.rectIds)].forEach(rectId => {
          this.allRectIds.push(rectId)
          return this.getSystemAppId(rectId, rects, isApp)
        })
        return this.handleDatas(item, rects, isApp)
      })
      return rects
    },
    // 将有外界数据源的样式 拼入appId  现在的appId 是单独提取出来的
    getSystemAppId(rectId, rects, isApp) {
      let appId
      const opt = this.getAttrById.call(
        this,
        this.$store.state[isApp ? "appStage" : this.request_prefix],
        {
          container_id: this.ids.container_id || 0,
          rect_id: rectId
        },
        "rect"
      )
      if (opt?.options?.appId) {
        appId = opt.options.appId
      } else if (opt && opt?.options?.myFetchParam && opt?.options?.appId !== undefined) {
        appId = opt.options.myFetchParam.appId
      } else if (opt && opt.appId !== undefined) {
        appId = opt.appId
      }
      if (appId) {
        this.saveAddIds.push(appId)
      }
      // 处理复杂组件的情况
      if (opt.shape === "cxAutoLayout" || opt.shape === "layoutComponent" || opt.shape === "emptyLayoutComponent" || opt.shape === "layoutComponentBigScreen" || opt.shape === "swiperComponent") {
        this.getChildAppId(opt.options, this.saveAddIds)
      }
      // 此操作放在 处理完动画关系之后 执行
      if (opt) {
        rects.push({
          rectId: rectId,
          appId: appId
        })
      }
      return rects
    },
    getChildAppId(rect, appIdArr) {
      if (!rect) return
      // 自由布局
      if (rect.innerElement === 'layoutComponent' || rect.innerElement === 'emptyLayoutComponent' || rect.innerElement === "layoutComponentBigScreen") {
        const allElementInLayout = getAllElementsInColsInLayoutComponent(rect.rows)
        for (let uid in allElementInLayout) {
          const col = allElementInLayout[uid]
          getAppId(col.elementOptions)
        }
      }
      // 轮播
      if (rect.innerElement === 'swiperComponent') {
        getAppId(rect.content)
      }
      // 自动布局
      if (rect.innerElement === 'cxAutoLayout') {
        getAppId(rect.elementOptions)
      }
      function getAppId(elementOptions) {
        elementOptions && Array.isArray(elementOptions) && elementOptions?.forEach(element => {
          if (element.appId) {
            appIdArr.push(element.appId)
          }
          if (element.elementOptions && Array.isArray(element.elementOptions)) {
            getAppId(element.elementOptions, appIdArr)
          }
        })
      }
    },
    handleParam(rectId, encAppId, changeAppId, isApp) {
      const ids = { container_id: this.ids.container_id || 0, rect_id: rectId }
      const env = isApp ? "appStage" : this.request_prefix
      let content = simpleDeepClone(this.getRectAttribute.call(this, ids, env))
      if (changeAppId) {
        content.options.appId = encAppId
        content.options.engineInstanceAppId = encAppId
        if (content.options.myFetchParam && content.options.myFetchParam.appId) {
          content.options.myFetchParam.appId = encAppId
        }
      }
      // 删除组件的 "滚动到可见的动画"
      // delAnimateGroup(content.options)
      content.options.event = getTarComponentEvent({ container_id: ids.container_id, rect_id: ids.rect_id })
      content.active = false
      //  删除所有组件在该通栏之外的动画
      delAnimateOutCurrentLayout(content, this.allRectIds, this.ids.container_id)

      const encType = "saveSystemModule"
      content = encryption(content, data_dictionary_map, encType)
      const param = {
        c: content, // 组件对用的属性
        a: encAppId
      }
      return param
    },
    createSystemComponentAppCollectFunc(moudle, isCopyHome, appMoudle) {
      let _self = this
      // 开始上传组件样式
      let selectPageLayout = simpleDeepClone(this.selectPageLayout)
      if(this.selectPageLayout.options.inDocument === 'relativeHeader'){
        selectPageLayout.options.inDocument = 'header'
        delete selectPageLayout.options.openHeaderRelation
        delete selectPageLayout.options.animateOfIn
        delete selectPageLayout.options.animateOfOut
      }
      let param = {
        c: JSON.stringify({
          rects: moudle.rects,
          ids: moudle.saveAddIds,
          pageLayout: selectPageLayout
        }),
        a: null,
        ma: true //通栏表示，不传表示为组件样式
      }
      if (appMoudle) {
        param.c3 = JSON.stringify({
          rects: appMoudle.rects,
          ids: appMoudle.saveAddIds,
          pageLayout: simpleDeepClone(this.appPageLayout)
        })
      }
      // 只是自己收藏 添加此参数
      param.coll = true
      param.t2 = this.systemLayoutType || this.systemLayoutId //类型 (比如大屏下的图文)
      param.t = this.systemLayoutForm.name //名字
      param.c2 = this.systemLayoutCover //封面
      const { websiteId, pageId, homePageId } = this.$store.state.states.getDataPageIds
      param.w = websiteId
      param.p = isCopyHome ? homePageId : pageId
      this.$API
         .createSystemComponentAppClone
        ({
          param: param
        })
        .then(res => {
          if (res?.data?.data?.moduleId) {
            _self.$message({
              customClass: "bigScreen_msg_backGroud",
              duration: 3000,
              type: "success",
              message: "保存成功"
            })
            _self.dialogSystemLayoutVal = false
            _self.systemLayoutForm.name = null
            _self.systemLayoutType = null
            _self.systemLayoutCover = ""
          }
        })
        .catch(err => {
          console.log("err", err)
          _self.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "error",
            message: err.message
          })
          _self.dialogSystemLayoutVal = false
        })
    },

    // 开始上传组件样式-新接口，不用重复调app-and-module了，appId也不用替换
    createSystemComponentAppCloneFunc(moudle, isCopyHome, appMoudle) {
      let _self = this
      // 开始上传组件样式
      let selectPageLayout = simpleDeepClone(this.selectPageLayout)
      if(this.selectPageLayout.options.inDocument === 'relativeHeader'){
        selectPageLayout.options.inDocument = 'header'
        delete selectPageLayout.options.openHeaderRelation
        delete selectPageLayout.options.animateOfIn
        delete selectPageLayout.options.animateOfOut
      }
      let param = {
        c: JSON.stringify({
          rects: moudle.rects,
          ids: moudle.saveAddIds,
          pageLayout: selectPageLayout
        }),
        a: null,
        ma: true //通栏表示，不传表示为组件样式
      }
      if (appMoudle) {
        param.c3 = JSON.stringify({
          rects: appMoudle.rects,
          ids: appMoudle.saveAddIds,
          pageLayout: simpleDeepClone(this.appPageLayout)
        })
      }
      param.t2 = this.systemLayoutType || this.systemLayoutId //类型 (比如大屏下的图文)
      param.t = this.systemLayoutForm.name //名字
      param.c2 = this.systemLayoutCover //封面
      const { websiteId, pageId, homePageId } = this.$store.state.states.getDataPageIds
      param.w = websiteId
      param.p = isCopyHome ? homePageId : pageId
      this.$API
          .createSystemComponentAppClone({
            param: param
          })
          .then(res => {
            if (res?.data?.data?.moduleId) {
              _self.$message({
                customClass: "bigScreen_msg_backGroud",
                duration: 3000,
                type: "success",
                message: "保存成功"
              })
              _self.dialogSystemLayoutVal = false
              _self.systemLayoutForm.name = null
              _self.systemLayoutType = null
              _self.systemLayoutCover = ""
            }
          })
          .catch(err => {
            console.log("err", err)
            _self.$message({
              customClass: "bigScreen_msg_backGroud",
              duration: 3000,
              type: "error",
              message: err.message
            })
            _self.dialogSystemLayoutVal = false
          })
    }
  }
}
</script>

<style scoped lang="scss"></style>
